import React, { forwardRef, useEffect } from 'react';
import './SearchResultDetailModal.css';

interface ResultDetailSidebarProps {
  children: React.ReactNode;
  isOpen: boolean;
  isVisible?: boolean;
  onClose: () => void;
  label: string;
  width?: number;
  className?: string;
  isResizing?: boolean;
  onResizeStart?: React.MouseEventHandler<HTMLDivElement>;
}

/** Shared right-side result surface; each workspace owns its result state. */
const ResultDetailSidebar = forwardRef<HTMLDivElement, ResultDetailSidebarProps>(({
  children, isOpen, isVisible = true, onClose, label, width = 900,
  className = '', isResizing = false, onResizeStart,
}, ref) => {
  useEffect(() => {
    if (!isOpen || !isVisible) return;
    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isOpen, isVisible, onClose]);

  return <div ref={ref} role="dialog" aria-label={label} aria-hidden={!isOpen || !isVisible}
    className={`search-result-detail-modal ${isOpen ? 'sidebar-open' : ''} ${isResizing ? 'resizing' : ''} ${className}`}
    style={{ width, maxWidth: '100vw', display: isVisible ? undefined : 'none' }}>
    {onResizeStart && <div className={`resize-handle ${isResizing ? 'resizing' : ''}`} onMouseDown={onResizeStart} />}
    {children}
  </div>;
});

export default ResultDetailSidebar;
